import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "redux/store";

interface IOilData {
	name: string;
	temp: number;
	press: number;
	pressStatus?: "Low" | "High";
	tempStatus?: "Low" | "High";
	remarks: string;
}

const oilsTableData: IOilData[] = [
	{
		name: "Cylinder Oil",
		temp: 57,
		press: 1.5,
		pressStatus: "Low",
		remarks:
			"Cylinder oil pressure is critically low. Immediate top-up required to prevent potential engine damage.",
	},
	{
		name: "System Oil",
		temp: 64,
		press: 3.1,
		tempStatus: "High",
		remarks:
			"The temperature is high. Please check for causes like overuse or leaks contributing to this issue.",
	},
	{
		name: "Stern Tube Oil",
		temp: 64,
		press: 3.1,
		tempStatus: "High",
		remarks:
			"The temperature is unusually high, possibly due to overconsumption or leaks in the system.",
	},
	{
		name: "Stern Tube Oil",
		temp: 64,
		press: 3.1,
		tempStatus: "High",
		remarks:
			"The temperature is unusually high, possibly due to overconsumption or leaks in the system.",
	},
	{
		name: "Stern Tube Oil",
		temp: 64,
		press: 3.1,
		tempStatus: "High",
		remarks:
			"The temperature is unusually high, possibly due to overconsumption or leaks in the system.",
	},
];

const StatusBadge = ({ status }: { status?: "Low" | "High" }) => {
	if (!status) return null;

	const isLow = status === "Low";
	const bgColor = isLow ? "bg-red-100" : "bg-red-100";
	const textColor = isLow ? "text-red-700" : "text-red-700";

	return (
		<span
			className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor}`}
		>
			<div className="w-1.5 h-1.5 rounded-full bg-red-500" />
			<span className="ml-1.5">{status}</span>
		</span>
	);
};

type OwnProps = {};
type OilTableProps = PropsFromRedux & OwnProps;
function OilTable(props: OilTableProps) {
	return (
		<div className="overflow-x-auto border border-b-none border-gray-300 rounded ws-scroll shadow-md h-[474px]">
			<table className="min-w-full overflow-x-auto divide-y divide-gray-200">
				<thead className="bg-gray-50 text-gray-600">
					<tr>
						<th className="px-3 py-2 text-left text-sm font-medium  whitespace-nowrap max-w-[200px]">
							Name
						</th>
						<th className="px-3 py-2 text-left text-sm font-medium  whitespace-nowrap max-w-[200px]">
							In temp
						</th>
						<th className="px-3 py-2 text-left text-sm font-medium whitespace-nowrap max-w-[200px]">
							In press
						</th>
						<th className="px-3 py-2 text-left text-sm font-medium w-full whitespace-nowrap">
							Remarks
						</th>
					</tr>
				</thead>
				<tbody className="bg-white">
					{oilsTableData?.map((row, idx) => (
						<tr key={idx} className="border-b last:border-0">
							<td className="px-3 py-4 text-sm whitespace-nowrap max-w-[200px]">
								{row.name}
							</td>
							<td className="px-3 py-4 text-sm whitespace-nowrap max-w-[200px]">
								<div className="flex items-center">
									{row.temp}
									<div className="ml-2">
										<StatusBadge status={row?.tempStatus} />
									</div>
								</div>
							</td>
							<td className="px-3 py-4 text-sm whitespace-nowrap max-w-[200px]">
								<div className="flex items-center">
									{row.press}
									<div className="ml-2">
										<StatusBadge status={row?.pressStatus} />
									</div>
								</div>
							</td>
							<td className="px-3 py-4 text-sm whitespace-wrap line-clamp-none xl:line-clamp-5">
								{row.remarks}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(OilTable);
